import ReactGA from 'react-ga'
import TagManager from 'react-gtm-module'
import { getAreCookiesAccepted } from 'services/cookies'

export const GOOGLE_ANALYTICS_ID =
  process.env.REACT_APP_GOOGLE_ANALYTICS_ID ||
  window.REACT_APP_GOOGLE_ANALYTICS_ID
export const GOOGLE_ANALYTICS_02_ID =
  process.env.REACT_APP_GOOGLE_ANALYTICS_02_ID ||
  window.REACT_APP_GOOGLE_ANALYTICS_02_ID
export const GOOGLE_TAG_MANAGER =
  process.env.REACT_APP_GOOGLE_TAG_MANAGER ||
  window.REACT_APP_GOOGLE_TAG_MANAGER

export const initGA = () => {
  if (getAreCookiesAccepted()) {
    if (GOOGLE_ANALYTICS_ID && GOOGLE_ANALYTICS_ID.length > 0) {
      ReactGA.initialize(GOOGLE_ANALYTICS_ID)
    }
    if (GOOGLE_ANALYTICS_02_ID && GOOGLE_ANALYTICS_02_ID.length > 0) {
      ReactGA.initialize(GOOGLE_ANALYTICS_02_ID)
    }
    if (GOOGLE_TAG_MANAGER && GOOGLE_TAG_MANAGER.length > 0) {
      const tagManagerArgs = {
        gtmId: GOOGLE_TAG_MANAGER,
      }
      TagManager.initialize(tagManagerArgs)
    }
  }
}
